export const typeToControlsMap = {
  country: ['country'],
  affiliate: ['affiliateUUID'],
  offer: ['offerUUID'],
  affiliateOffer: ['affiliateUUID', 'offerUUID'],
  countryAffiliate: ['country', 'affiliateUUID'],
  countryOffer: ['country', 'offerUUID'],
  countryAffiliateOffer: ['country', 'affiliateUUID', 'offerUUID'],
  affiliateAffSub: ['affiliateUUID', 'affSub'],
  affSubAffSource: ['affSub', 'affiliateSource'],
  dayOfWeek: ['dayOfWeek'],
  hourOfDay: ['hourOfDayFrom', 'hourOfDayTo'],
  dayOfWeekHourOfDay: ['dayOfWeek', 'hourOfDayFrom', 'hourOfDayTo'],
  advertiser: ['advertiserUUID'],
  advertiserCountry: ['advertiserUUID', 'country'],
  free: ['pql'],
  offerUrl: ['offerUUID', 'offerURLUUID'],
  os: ['os'],
  devices: ['devices'],
  deviceBrands: ['deviceBrands'],
  browsers: ['browsers'],
  regions: ['regions'],
  mobileCarriers: ['mobileCarriers'],
  goalType: ['goalTypeUUID'],
};

export const hoursFromData = {
  0: '00:00',
  1: '01:00',
  2: '02:00',
  3: '03:00',
  4: '04:00',
  5: '05:00',
  6: '06:00',
  7: '07:00',
  8: '08:00',
  9: '09:00',
  10: '10:00',
  11: '11:00',
  12: '12:00',
  13: '13:00',
  14: '14:00',
  15: '15:00',
  16: '16:00',
  17: '17:00',
  18: '18:00',
  19: '19:00',
  20: '20:00',
  21: '21:00',
  22: '22:00',
  23: '23:00',
};

export const hoursToData = {
  1: '00:59',
  2: '01:59',
  3: '02:59',
  4: '03:59',
  5: '04:59',
  6: '05:59',
  7: '06:59',
  8: '07:59',
  9: '08:59',
  10: '09:59',
  11: '10:59',
  12: '11:59',
  13: '12:59',
  14: '13:59',
  15: '14:59',
  16: '15:59',
  17: '16:59',
  18: '17:59',
  19: '18:59',
  20: '19:59',
  21: '20:59',
  22: '21:59',
  23: '22:59',
  24: '23:59',
};

export const daysData = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const affSubData = {
  affiliateSub1: 'AffSub1',
  affiliateSub2: 'AffSub2',
  affiliateSub3: 'AffSub3',
  affiliateSub4: 'AffSub4',
  affiliateSub5: 'AffSub5',
};

export const targetTags = {
  os: 'OS',
  devices: 'Devices',
  deviceBrands: 'Device Brands',
  browsers: 'Browsers',
  regions: 'Regions',
  mobileCarriers: 'Mobile Carriers',
};
